var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 194,
    viewBox: "0 0 232 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-121.5 -1993)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_87_",
    "data-name": "87%",
    transform: "translate(237.5 2112)",
    fill: "#405968",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -80.05,
    y: 0
  }, "87"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "of_our_callers",
    "data-name": "of our callers",
    transform: "translate(237.5 2140)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65.37,
    y: 0
  }, "OF OUR CALLERS")), /*#__PURE__*/React.createElement("text", {
    id: "are_experiencing_isolation_as_the_result_of_a_controlling_partner",
    "data-name": "are experiencing isolation as the result of a controlling partner",
    transform: "translate(237.5 2164)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -98.94,
    y: 0
  }, "are experiencing isolation as"), /*#__PURE__*/React.createElement("tspan", {
    x: -115.532,
    y: 20
  }, "the result of a controlling partner")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.a7f01a6b0ac1fe130606d6140235de72.svg";
export { ForwardRef as ReactComponent };